import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/INSTAR_Cloud_Alarme_Ihrer_IP_Kameras_verwalten_und_herunterladen.mp4" />
        </Player>
        <EuiText>
            <p>In diesem Video zeigen wir Ihnen wie man auf einfache Weise die Alarme in Ihrem INSTAR Cloud Account anschauen und verwalten kann. Auf <OutboundLink href="https://www.youtube.com/watch?v=PDc6_BsczRY" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard